import React from 'react';
import { Rhythm, RhythmScale } from '../Theme';
import styles from './Box.module.css';

interface AxisPadding {
  horizontal?: RhythmScale;
  vertical?: RhythmScale;
}

interface SidePadding {
  top?: RhythmScale;
  bottom?: RhythmScale;
  left?: RhythmScale;
  right?: RhythmScale;
}

export interface BoxProps {
  // choose rhythm size
  padding?: RhythmScale | AxisPadding | SidePadding;

  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

function isAxisPadding(
  padding: AxisPadding | SidePadding
): padding is AxisPadding {
  const axisPadding = padding as AxisPadding;
  return axisPadding.horizontal != null || axisPadding.vertical != null;
}

const getPadding = (padding?: RhythmScale) => {
  switch (padding) {
    case 'xs':
      return Rhythm.xs;
    case 'sm':
      return Rhythm.sm;
    case 'md':
      return Rhythm.md;
    case 'lg':
      return Rhythm.lg;
    case 'xl':
      return Rhythm.xl;
    default:
      return '0px';
  }
};

export const Box: React.FC<BoxProps> = ({
  padding,
  width,
  height,
  style,
  children,
}) => {
  const boxStyles: any = {
    '--box-height': height ? `${height}px` : '100%',
    '--box-width': width ? `${width}px` : '100%',
  };

  if (!padding || typeof padding == 'string') {
    boxStyles['--box-padding-left'] = getPadding(padding);
    boxStyles['--box-padding-right'] = getPadding(padding);
    boxStyles['--box-padding-top'] = getPadding(padding);
    boxStyles['--box-padding-bottom'] = getPadding(padding);
  } else if (isAxisPadding(padding)) {
    boxStyles['--box-padding-left'] = getPadding(padding.horizontal);
    boxStyles['--box-padding-right'] = getPadding(padding.horizontal);
    boxStyles['--box-padding-top'] = getPadding(padding.vertical);
    boxStyles['--box-padding-bottom'] = getPadding(padding.vertical);
  } else {
    boxStyles['--box-padding-left'] = getPadding(padding.left);
    boxStyles['--box-padding-right'] = getPadding(padding.right);
    boxStyles['--box-padding-top'] = getPadding(padding.top);
    boxStyles['--box-padding-bottom'] = getPadding(padding.bottom);
  }

  return (
    <div className={styles.box} style={{ ...boxStyles, ...style }}>
      {children}
    </div>
  );
};
